import { createContext, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { empresasService } from "app/services";

const TelefonoContext = createContext();

const initialState = {
  telefono_numero: "",
  telefono_principal: false,
};

export function TelefonoProvider({ children }) {
  const params = useParams();

  const [telefono, setTelefono] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const telefonoQuery = useQuery({
    queryKey: ["empresa:get:telefono", params.empresa_id, params.telefono_id],
    queryFn: () =>
      empresasService.getTelefono({
        empresaId: params.empresa_id,
        telefonoId: params.telefono_id,
      }),
    onSuccess: (data) => {
      setTelefono(data);
      setEditing(true);
    },
    enabled: !!params.telefono_id,
  });

  if (!!telefonoQuery.isLoading && !!params.telefono_id) {
    return <Spinner label="Cargando el número de teléfono..." />;
  } else if (!!telefonoQuery.isFetching && !!params.telefono_id) {
    return <Spinner label="Recuperando el número de teléfono..." />;
  } else if (!!telefonoQuery.isRefetching && !!params.telefono_id) {
    return <Spinner label="Recargando el número de teléfono..." />;
  } else if (!!telefonoQuery.isError) {
    return <ErrorMessage message={telefonoQuery.error.response.statusText} />;
  }

  return (
    <TelefonoContext.Provider
      value={{
        telefono,
        setTelefono,
        isEditing,
      }}
    >
      {children}
    </TelefonoContext.Provider>
  );
}

export function useTelefonoContext() {
  const telefonoContext = useContext(TelefonoContext);

  if (!telefonoContext) {
    throw new Error(
      "useTelefonoContext should be used inside the TelefonoProvider."
    );
  }

  return telefonoContext;
}
